/**
 * @generated SignedSource<<d00542dc4d5da27d53055b2e0484e066>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DebriefStatus = "DONE" | "FAILED" | "PENDING" | "RUNNING" | "%future added value";
export type ErrorKind = "DISCOURSE" | "GRAMMAR" | "LEXIS" | "PROSODY" | "%future added value";
export type PracticeResult = "RECURRED" | "TARGETED" | "USED_CORRECTLY" | "%future added value";
export type SessionStatus = "ACTIVE" | "DEBRIEFED" | "DEBRIEFING" | "ENDED" | "FAILED" | "%future added value";
export type Severity = "BLOCKING" | "MINOR" | "POLISH" | "%future added value";
export type DebriefViewQuery$variables = {
  sessionId: string;
};
export type DebriefViewQuery$data = {
  readonly session: {
    readonly debrief: {
      readonly focusAreas: ReadonlyArray<{
        readonly kind: ErrorKind;
        readonly turns: ReadonlyArray<{
          readonly audioUrl: string | null | undefined;
          readonly errors: ReadonlyArray<{
            readonly explanation: string;
            readonly id: string;
            readonly learnerForm: string;
            readonly severity: Severity;
            readonly span: {
              readonly end: number;
              readonly start: number;
            } | null | undefined;
            readonly targetForm: string;
          }>;
          readonly id: string;
          readonly transcript: string;
        }>;
        readonly why: string;
      }>;
      readonly generatedAt: any | null | undefined;
      readonly goal: {
        readonly parts: ReadonlyArray<boolean>;
        readonly reached: boolean;
      } | null | undefined;
      readonly id: string;
      readonly language: string | null | undefined;
      readonly model: string;
      readonly status: DebriefStatus;
      readonly strengths: ReadonlyArray<string>;
      readonly summary: string;
    } | null | undefined;
    readonly practice: ReadonlyArray<{
      readonly item: {
        readonly exemplar: {
          readonly learnerForm: string;
          readonly targetForm: string;
        } | null | undefined;
        readonly id: string;
        readonly kind: ErrorKind;
        readonly pattern: string;
      };
      readonly outcome: PracticeResult;
    }>;
    readonly practisedWord: {
      readonly item: {
        readonly id: string;
        readonly word: string;
      };
      readonly outcome: PracticeResult;
    } | null | undefined;
    readonly status: SessionStatus;
    readonly topic: string | null | undefined;
  } | null | undefined;
};
export type DebriefViewQuery = {
  response: DebriefViewQuery$data;
  variables: DebriefViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sessionId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "sessionId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "topic",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "learnerForm",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetForm",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Debrief",
  "kind": "LinkedField",
  "name": "debrief",
  "plural": false,
  "selections": [
    (v4/*:: as any*/),
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "strengths",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "model",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "generatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DebriefGoal",
      "kind": "LinkedField",
      "name": "goal",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reached",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "parts",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FocusArea",
      "kind": "LinkedField",
      "name": "focusAreas",
      "plural": true,
      "selections": [
        (v5/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "why",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Turn",
          "kind": "LinkedField",
          "name": "turns",
          "plural": true,
          "selections": [
            (v4/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "transcript",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "audioUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ErrorRecord",
              "kind": "LinkedField",
              "name": "errors",
              "plural": true,
              "selections": [
                (v4/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "severity",
                  "storageKey": null
                },
                (v6/*:: as any*/),
                (v7/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "explanation",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ErrorSpan",
                  "kind": "LinkedField",
                  "name": "span",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "start",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "end",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "outcome",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "PracticeOutcome",
  "kind": "LinkedField",
  "name": "practice",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PracticeItem",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        (v4/*:: as any*/),
        (v5/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pattern",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Exemplar",
          "kind": "LinkedField",
          "name": "exemplar",
          "plural": false,
          "selections": [
            (v6/*:: as any*/),
            (v7/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v9/*:: as any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "WordPractice",
  "kind": "LinkedField",
  "name": "practisedWord",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "VocabularyItem",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        (v4/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "word",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v9/*:: as any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DebriefViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v8/*:: as any*/),
          (v10/*:: as any*/),
          (v11/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "DebriefViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v8/*:: as any*/),
          (v10/*:: as any*/),
          (v11/*:: as any*/),
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "722e9c3474f9b810975f25813f9afa5c",
    "id": null,
    "metadata": {},
    "name": "DebriefViewQuery",
    "operationKind": "query",
    "text": "query DebriefViewQuery(\n  $sessionId: ID!\n) {\n  session(id: $sessionId) {\n    status\n    topic\n    debrief {\n      id\n      status\n      summary\n      strengths\n      model\n      generatedAt\n      language\n      goal {\n        reached\n        parts\n      }\n      focusAreas {\n        kind\n        why\n        turns {\n          id\n          transcript\n          audioUrl\n          errors {\n            id\n            severity\n            learnerForm\n            targetForm\n            explanation\n            span {\n              start\n              end\n            }\n          }\n        }\n      }\n    }\n    practice {\n      item {\n        id\n        kind\n        pattern\n        exemplar {\n          learnerForm\n          targetForm\n        }\n      }\n      outcome\n    }\n    practisedWord {\n      item {\n        id\n        word\n      }\n      outcome\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4ea1ab0e76dfc6d9e40b0b5c98b7286b";

export default node;
